import { render, staticRenderFns } from "./StoricoPrelievi.vue?vue&type=template&id=4b913122&scoped=true"
import script from "./StoricoPrelievi.vue?vue&type=script&lang=js"
export * from "./StoricoPrelievi.vue?vue&type=script&lang=js"
import style0 from "./StoricoPrelievi.vue?vue&type=style&index=0&id=4b913122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b913122",
  null
  
)

export default component.exports